module.exports = __webpack_public_path__ + "static/media/report.6e4efaba.png";